import { useEffect, useState } from 'react';
import Card, { CardHeader } from '../../../components/card/Card';
import PageLayout, {
  PageHeader,
} from '../../../components/page_layout/PageLayout';
import { InputField } from '../../../components/text_field/TextField';
import { ProposalPreviewFormContainer } from './ProposalPreview.elements';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { LoadingElement } from '../../../components/loading/Loading';

const ProposalPreview = () => {
  const { id } = useParams();
  const [get, setGet] = useState(true);
  const [dataProposal, setDataProposal] = useState([]);
  const [visible, setVisible] = useState(false);
  const [form, setForm] = useState({
    type_of_proposal: '',
    phone_number: '',
    admin_name: '',
    position: '',
    gpu: '',
    ram: '',
    storage: '',
    leader_name: '',
    pic: '',
    institution: '',
    duration: '',
    data_description: '',
    shared_data: '',
    collaboration_plan: '',
    research_field: '',
    short_description: '',
    activity_plan: '',
    output_plan: '',
    previous_experience: '',
    research_fee: '',
    previous_docker_image: '',
    previous_proposal_file: '',
    previous_adhoc: '',
    previous_anggaran: '',
    previous_collaboration: '',
    previous_institution_file: '',
    previous_application_file: '',
    status: '',
    error_list: [],
  });

  useEffect(() => {
    const GetDetail = () => {
      var url = '';
      if (localStorage.getItem('role') === 'Internal') {
        url = 'user-internal';
      } else if (localStorage.getItem('role') === 'External') {
        url = 'user-external';
      }

      axios.get(`/api/${url}/revisishow/${id}`).then((res) => {
        if (res.data.meta.code === 200) {
          if (res.data.data.proposal_revisi.length !== 0) {
            setDataProposal(res.data.data.proposal_revisi);
            setVisible(true);
          }
        }
      });

      axios
        .get('/api/' + url + '/proposal-industri-submission/show/' + id)
        .then((res) => {
          if (res.data.meta.code === 200) {
            const hasil = res.data.data;
            setForm({
              type_of_proposal: hasil.submission.type_of_proposal,
              phone_number: hasil.submission.phone_number,
              admin_name: hasil.submission.admin_name,
              position: hasil.submission.position,
              leader_name: hasil.submission.leader_name,
              gpu: hasil.submission.gpu,
              ram: hasil.submission.ram,
              storage: hasil.submission.storage,
              partner: hasil.submission.partner,
              duration: hasil.submission.duration,
              pic: hasil.submission.pic,
              institution: hasil.submission.institution,
              collaboration_plan: hasil.submission.collaboration_plan,
              short_description: hasil.submission.short_description,
              data_description: hasil.submission.data_description,
              shared_data: hasil.submission.shared_data === 1 ? 'yes' : 'no',
              activity_plan: hasil.submission.activity_plan,
              output_plan: hasil.submission.output_plan,
              previous_experience: hasil.submission.previous_experience,
              research_fee: hasil.submission.research_fee,
              previous_docker_image: hasil.submission.docker_image,
              previous_proposal_file: hasil.submission.proposal_file,
              previous_adhoc: hasil.submission.adhoc_file,
              previous_anggaran: hasil.submission.anggaran_file,
              previous_collaboration: hasil.submission.collaboration_file,
              previous_institution_file: hasil.submission.institution_file,
              previous_application_file: hasil.submission.application_file,
              status: hasil.submission.status,
              error_list: [],
            });
          }
          setGet(false);
        });
    };

    GetDetail();
  }, [id]);

  var status = '';

  if (form.status === 'Pending') {
    status = 'Belum Disetujui';
  } else if (form.status === 'Approved') {
    status = 'Disetujui';
  } else if (form.status === 'Rejected') {
    status = 'Ditolak';
  } else if (form.status === 'Revision') {
    status = 'Revisi';
  } else if (form.status === 'Finished') {
    status = 'Selesai';
  }

  if (get) {
    return <LoadingElement />;
  }

  return (
    <>
      <PageLayout>
        <PageHeader title="Pratinjau Usulan Industri" />
        {visible ? (
          <div
            style={{
              backgroundColor: '#5B3A89',
              padding: '1rem',
              marginBottom: '2rem',
              borderRadius: '5px',
              color: '#ffffff',
            }}
          >
            <h3 style={{ color: '#ffffff' }}>Catatan Revisi</h3>
            <div style={{ padding: '0.5rem 0 0 2rem' }}>
              {dataProposal.map((res) => (
                <div dangerouslySetInnerHTML={{ __html: res.catatan }}></div>
              ))}
            </div>
          </div>
        ) : null}
        <Card>
          <CardHeader title="Formulir Pengajuan Usulan" />
          <ProposalPreviewFormContainer>
            <InputField
              label="Jenis Penelitian"
              value={form.type_of_proposal}
              readOnly
            />
            <InputField
              label="Nomor Handphone"
              value={form.phone_number}
              readOnly
            />
            <InputField
              label="Nama Admin Tim AdHoc Internal UG"
              value={form.admin_name}
              readOnly
            />
            <InputField
              label="Posisi dalam Tim AdHoc Internal"
              value={form.position}
              readOnly
            />
            <InputField
              label="Surat Pengajuan Penggunaan DGX"
              type="see-file"
              onClicked={() =>
                window.open(
                  process.env.REACT_APP_API_URL +
                    '/application_dgx/file/' +
                    form.previous_application_file,
                  '_blank'
                )
              }
            />
            <InputField label="Jumlah GPU / (GB)" value={form.gpu} readOnly />
            <InputField label="Jumlah RAM / (GB)" value={form.ram} readOnly />
            <InputField
              label="Jumlah Storage / (GB)"
              value={form.storage}
              readOnly
            />
            <InputField
              label="Nama Ketua Tim AdHoc"
              value={form.leader_name}
              readOnly
            />
            <InputField
              label="Nama Penanggung Jawab External"
              value={form.pic}
              readOnly
            />
            <InputField
              label="Nama Institusi Eksternal"
              value={form.institution}
              readOnly
            />
            <InputField
              label="Durasi / (Hari)"
              value={form.duration}
              readOnly
            />
            <InputField
              label="Deskripsi Data"
              value={form.collaboration_plan}
              type="textarea"
              id="data_description"
              readOnly
            />
            <InputField
              label="Menggunakan Data Bersama"
              value={form.shared_data === 'yes' ? 'Iya' : 'Tidak'}
              readOnly
            />
            <InputField
              label="Bentuk Kegiatan Kerjasama"
              value={form.collaboration_plan}
              readOnly
            />
            <InputField
              label="Rencana Kegiatan"
              value={form.activity_plan}
              id="activity_plan"
              type="textarea"
              readOnly
            />
            <InputField
              label="Biaya Penelitian"
              value={form.research_fee}
              type="currency"
              readOnly
            />
            {/* <InputField
              label="Docker Image"
              value={form.docker_image}
              readOnly
            /> */}
            <InputField
              label="Docker Image"
              type="see-file"
              onClicked={() =>
                window.open(
                  process.env.REACT_APP_API_URL +
                    '/docker/file/' +
                    form.docker_image,
                  '_blank'
                )
              }
            />
            <InputField
              label="Scan Dokumen Kerjasama"
              type="see-file"
              onClicked={() =>
                window.open(
                  process.env.REACT_APP_API_URL +
                    '/collaboration/file/' +
                    form.previous_collaboration,
                  '_blank'
                )
              }
            />
            <InputField
              label="Scan Dokumen Tim AdHoc UG"
              type="see-file"
              onClicked={() =>
                window.open(
                  process.env.REACT_APP_API_URL +
                    '/adhoc/file/' +
                    form.previous_adhoc,
                  '_blank'
                )
              }
            />
            <InputField
              label="Profil Institusi External"
              type="see-file"
              onClicked={() =>
                window.open(
                  process.env.REACT_APP_API_URL +
                    '/institution/file/' +
                    form.previous_institution_file,
                  '_blank'
                )
              }
            />
            <InputField
              label="Proposal Kegiatan"
              type="see-file"
              onClicked={() =>
                window.open(
                  process.env.REACT_APP_API_URL +
                    '/proposal/file/' +
                    form.previous_proposal,
                  '_blank'
                )
              }
            />
            <InputField
              label="Rencana Anggaran"
              type="see-file"
              onClicked={() =>
                window.open(
                  process.env.REACT_APP_API_URL +
                    '/anggaran/file/' +
                    form.previous_anggaran,
                  '_blank'
                )
              }
            />
            <InputField label="Status" value={status} readOnly />
          </ProposalPreviewFormContainer>
        </Card>
      </PageLayout>
    </>
  );
};

export default ProposalPreview;
